import { throttle, loadLibrary } from '../modules/Util.js';
import { LIB_URL } from '../App';


let debug = false;
const $products = $('.js-store-product,.slider-products__wrap,.js-product-card');
const $orderForms = $('.js-order-form');
const isPageProduct = App.H.is('.page-product-store');

if ($products.length) {
    const $filter = $('.products-store-filter > .js-products-filter-form');

    if ($filter.length) {
        const $productWrap = $('.js-products-wrapper');
        const filterSelects = Array.from($('.js-products-filter-select', $filter));

        if (filterSelects.some(select => select.selectedIndex != 0)) {
            $productWrap.attr('data-ec-list', ['Фильтр'].concat(filterSelects.filter(select => select.selectedIndex != 0).map(select => select.options[select.selectedIndex].innerHTML)).join('/'));
        }
    }

    App.W.on('scroll', throttle(inViewport, 100));
    App.D.on('ec:inViewport', inViewport);
    inViewport();

    $products.closest('.swiper-wrapper').parent().each((i, swiperDom) => {
        loadLibrary(LIB_URL.SWIPER, () => {
            if (swiperDom.swiper) {
                swiperDom.swiper.on('slideChangeTransitionEnd', inViewport);
            } else {
                let timer = setInterval(() => {
                    if (swiperDom.swiper) {
                        clearInterval(timer);
                        swiperDom.swiper.on('slideChangeTransitionEnd', inViewport);
                    }
                }, 500);
            }
        });
    });

    // клик по товару в каталоге т.е. переход по ссылке
    App.D.on('click', '.js-store-product > a, .slider-products__wrap .link-arrow', (e) => {
        //e.preventDefault();
        if (!$(e.target).closest('.js-to-basket').length) {
            productClick($(e.currentTarget).closest('[data-ec-product]')[0], e.currentTarget.href);
        }
    });

    // клик по кнопке добавить в корзину или +1
    App.D.on('click', '.js-to-basket, .js-quantity-plus', (e) => {
        addToCart($(e.currentTarget).closest('[data-ec-product]')[0], e.currentTarget);
    });

    // -1
    App.D.on('click', '.js-quantity-minus', (e) => {
        removeFromCart($(e.currentTarget).closest('[data-ec-product]')[0], e.currentTarget);
    });
}

if (isPageProduct) {
    const $product = $products.filter('.single-product-wrap');

    productDetail($product[0]);
}

if ($orderForms.length) {
    App.D.on('checkout', (e, data) => {
        checkout(data);
    });

    App.D.trigger('checkout', {
        step: 1,
        option: 'Корзина'
    });

    App.D.on('purchase', (e, data) => {
        purchase(data);
    });

    // plus +1
    App.D.on('click', '.js-product-action[data-action="plus"]', (e) => {
        addToCart($(e.currentTarget).closest('[data-ec-product]')[0], e.currentTarget);
    });

    // remove, -1
    App.D.on('click', '.js-product-action[data-action="minus"], .js-product-action[data-action="remove"]', (e) => {
        removeFromCart($(e.currentTarget).closest('[data-ec-product]')[0], e.currentTarget);
    });
}

// ProductImpressions
function ProductImpressions (productDomArray) {
    !debug || console.log('ecImpressions', productDomArray);
    const products = productDomArray
        .filter(productDom => {
            return !$(productDom).is('.single-product-wrap');
        })
        .map(productDom => {
            return getProductData(productDom);
        });

    if (products.length) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ecommerce: null});

        // 'id': {productObj.id}, // Идентификатор или код товара
        // 'name': {productObj.name}, // Название товара
        // 'price': {productObj.price}, // Цена товара
        // 'category': {productObj.cat}, // Категория, к которой относится товар
        // 'list': {productObj.list}, // Список в который добавлен товар
        // 'position': {productObj.position} // Позиция товара в списке

        window.dataLayer.push({
            'event':'ProductImpressions',
            'ecommerce': {
                'impressions': products
            }
        });
    }
}

function inViewport () {
    const selector = '.js-store-product:not(.ec-viewed), .slider-products__wrap:not(.ec-viewed), .js-product-card:not(.ec-viewed)';
    const w = document.documentElement.clientWidth;
    const h = document.documentElement.clientHeight;
    let viewedProducts = [];

    $(selector).each(function () {
        const data = this.getBoundingClientRect();
        const persent = (((data.right > w ? w : data.right < 0 ? 0 : data.right) - (data.left > w ? w : data.left < 0 ? 0 : data.left)) * ((data.bottom > h ? h : data.bottom < 0 ? 0 : data.bottom) - (data.top > h ? h : data.top < 0 ? 0 : data.top))) / (data.width * data.height);

        if (persent > 0.75) {
            // var $tabsliderItem = $(this).closest('.js-tabslider-list-item');
            // if ($tabsliderItem.length && !$tabsliderItem.hasClass('__active')) return;

            $(this).addClass('ec-viewed');
            viewedProducts.push(this);
        }
    });
    if (viewedProducts.length) ProductImpressions(viewedProducts);
}

function getProductData (productDom) {
    const $product = $(productDom);
    const data = $product.data('ec-product');
    if (!data) return;
    const productData = {
        id: data.id + '',
        name: data.name,
        price: parseInt(data.price),
        category: data.category
    };

    const list = $product.closest('[data-ec-list]').data('ec-list');

    if (list) productData.list = list;

    if ($product.siblings('.js-store-product').length) {
        productData.position = $product.index() + 1;
    } else if ($product.closest('.swiper-slide').length) {
        productData.position = parseInt($product.closest('.swiper-slide').attr('data-swiper-slide-index') || $product.closest('.swiper-slide').index()) + 1;
    }
    return productData;
}

// productClick
function productClick (productDom, url) {
    const productData = getProductData(productDom);
    if (!productData) return;
    const list = productData.list;

    delete productData.list;

    localStorage.setItem(url, list);

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ecommerce: null});
    window.dataLayer.push({
        'event': 'productClick',
        'ecommerce': {
            'click': {
                'actionField': {
                    'list': list //Cписок из которого был кликна товар
                },
                'products': [productData]
            }
        },
        /*'eventCallback': function() {
            document.location = url;
        }*/
    });
}

// productDetail
function productDetail (productDom) {
    const productData = getProductData(productDom);
    if (!productData) return;
    let list = productData.list;

    delete productData.list;

    if (localStorage[document.location]) {
        list = localStorage[document.location];
        delete localStorage[document.location];
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ecommerce: null});
    window.dataLayer.push({
        'event': 'productDetail',
        'ecommerce': {
            'detail': {
                'actionField': {
                    'list': list //Cписок из которого был открыт товар
                },
                'products': [productData]
            }
        }
    })
}

// addToCart
function addToCart (productDom) {
    const productData = getProductData(productDom);
    if (!productData) return;
    const list = productData.list;

    delete productData.list;
    productData.quantity = 1;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ecommerce: null});
    window.dataLayer.push({
        'event': 'addToCart',
        'ecommerce': {
            'add': {
                'actionField': {
                    'list': list // Cписок из которого был добавлен товар в корзину, либо 'Карточка' - при добавление товара в корзину из карточки товара
                },
                'products': [productData]
            }
        }
    })
}

// removeFromCart
function removeFromCart (productDom, target) {
    const productData = getProductData(productDom);
    if (!productData) return;
    const list = productData.list;

    delete productData.list;
    productData.quantity = $(target).data('action') == 'remove' ? $(target).closest('.js-product-item').find('[name="quantity"]').val() : 1;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ecommerce: null});
    window.dataLayer.push({
        'event': 'removeFromCart',
        'ecommerce': {
            'remove': {
                'actionField': {
                    'list': list // Cписок из которого был добавлен товар в корзину, либо 'Карточка' - при добавление товара в корзину из карточки товара
                },
                'products': [productData]
            }
        }
    })
}

// checkout
function checkout (actionField) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ecommerce: null});
    window.dataLayer.push({
        'event': 'checkout',
        'ecommerce': {
            'checkout': {
                'actionField': actionField,
                'products': getCheckoutProducts()
            }
        }
    });
}

function getCheckoutProducts() {
    const productsData = [];

    $('.js-order-form[data-ec-step="1"] .js-product-item').each((i, productDom) => {
        const data = $(productDom).data('ec-product');

        data.quantity = $(productDom).find('[name="quantity"]').val();
        productsData.push(data);
    });

    return productsData;
}

// purchase
function purchase (actionField) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ecommerce: null});
    window.dataLayer.push({
        'event': 'purchase',
        'ecommerce': {
            'purchase': {
                'actionField': actionField,
                'products': getCheckoutProducts()
            }
        }
    })
}
